import classNames from 'classnames/bind';

import styles from './index.module.scss';
import Marquee from '../../../components/Marquee';

const cx = classNames.bind(styles);

const S07 = () => {
  return (
    <section className={cx('container')}>
      <Marquee isColorBlack={false} />
    </section>
  );
};

export default S07;
